import { Platform, Pressable } from 'react-native';
import { useTheme, YStack, Text } from 'tamagui';
import { Mic } from '@tamagui/lucide-icons';
import { FloatingAction } from 'react-native-floating-action';

interface IGlobalAnimationSearchProps {
  handleSearch: (value: boolean) => void;
}

export const HomeScreenMic = ({ handleSearch }: IGlobalAnimationSearchProps) => {
  const theme = useTheme();
  return (
    <>
      {Platform.OS !== 'web' ? (
        <FloatingAction
          onPressMain={() => handleSearch(true)}
          overlayColor={'transparent'}
          color={theme['homeFloatingButtonBg']?.val}
          buttonSize={76}
          floatingIcon={
            <YStack alignItems="center">
              <Mic color={'#FFF'} size={26} fontSize={12} />
            </YStack>
          }
        />
      ) : (
        <Pressable
        testID="kisan_tId_Home_MicButton"
          style={{
            position: 'absolute',
            bottom: 100,
            right: 30,
            width: 76,
            height: 76,
            borderRadius: 38,
            backgroundColor: theme['homeFloatingButtonBg']?.val,
            justifyContent: 'center',
            alignItems: 'center',
            shadowColor: '#000',
            shadowOffset: { width: 0, height: 2 },
            shadowOpacity: 0.8,
            shadowRadius: 2,
            elevation: 5,
          }}
          onPress={() => handleSearch(true)}
        >
          <YStack alignItems="center">
            <Mic color={'#FFF'} size={18} fontSize={12} />
          </YStack>
        </Pressable>
      )}
    </>
  );
};
